import React from 'react';
import i18n from 'i18next';
import {
  useHistory,
} from 'react-router-dom';

import {
  getEntityPath,
} from 'web-utils';

import {
  Icon,
  Button,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

type Item = {
  id: number,
  name: string,
  is_root: boolean,
  basePath: string,
};

type Props = {
  items: Item[],
  basePath: string,
  hideBackChevron?: boolean,
  backPath?: string,
  parentId?: number,
  entityFolderId?: number,
  onChangeLastItem?: { (name: string): void },
};

const Breadcrumbs = ({
  basePath,
  items,
  hideBackChevron,
  backPath,
  parentId,
  entityFolderId,
  onChangeLastItem,
}: Props) => {
  const history = useHistory();

  return (
    <Flex
      align="center"
      spacing={10}
    >
      {
        !hideBackChevron && (
          <Button
            appearance="link"
            onClick={() => {
              if (backPath && entityFolderId) {
                history.push(`${backPath}/${entityFolderId}`);
              } else if (backPath && parentId) {
                history.push(`${backPath}/${parentId}`);
              } else {
                history.goBack();
              }
            }}
            noPrint
          >
            <Icon type="fa fa-chevron-left" />
          </Button>
        )
      }
      <Flex wrap="wrap" spacing={10}>
        {items.map((item, i) => {
          const isLast = i > 0 && i === items.length - 1;
          if (isLast && onChangeLastItem) {
            return (
              <S.EditableItem
                key={item.id}
                html={item.name}
                onChange={() => {}}
                onBlur={(e) => {
                  onChangeLastItem(e.target.textContent || '');
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    const div = e.target as HTMLElement;
                    onChangeLastItem(div.textContent || '');
                  }
                }}
              />
            );
          }
          return (
            <S.Item
              key={item.id}
              to={getEntityPath(item, item.basePath || basePath)}
              selected={isLast}
            >
              {item.is_root ? i18n.t(item.name) : item.name}
            </S.Item>
          );
        })}
      </Flex>
    </Flex>
  );
};

Breadcrumbs.defaultProps = {
  hideBackChevron: false,
  backPath: '',
  parentId: '',
  entityFolderId: '',
  onChangeLastItem: null,
};

export default Breadcrumbs;
